import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { FormData, MerchantDetails } from './types';

const formatDate = (date: Date | null) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const submitAnswers = ({
  bic,
  iban,
  merchantId,
  paymentReference,
  previousCompanyNames,
  leiNumber,
  usaConnection,
  businessOperations,
  reasonForUse,
  authorizedSignatory,
  primaryAddress,
  incorporationDate,
}: FormData) => {
  const merchant = {
    paymentDetails: {
      bic,
      iban,
      reference: paymentReference,
    },
    merchantId,
  };

  const kyb = {
    previousCompanyNames,
    leiNumber,
    usaConnection,
    businessOperations,
    reasonForUse,
    authorizedSignatory,
    primaryAddress,
    incorporationDate: formatDate(incorporationDate),
  };
  return fetchAPI(`v1/merchant`, {
    method: 'PATCH',
    body: {
      merchant,
      kyb,
    },
  });
};

export const getMerchant = (merchant_id: string) =>
  fetchAPI<MerchantDetails>(`v1/merchant/${merchant_id}`);

export const getKYB = async (merchantId: string): Promise<FormData> => {
  const response = await fetchAPI<FormData>(`v1/organizations/${merchantId}`);
  return {
    ...response,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    incorporationDate: new Date(response.incorporationDate!),
    relatedPeople: response.relatedPeople.map((p) => ({
      ...p,
      dateOfBirth: new Date(p.dateOfBirth),
    })),
    authorizedSignatory: response.authorizedSignatory || '',
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    primaryAddress: response.primaryAddress || {
      postalRegion: '',
      postalNumber: '',
      country: '',
      address1: '',
    },
    usaConnection: response.usaConnection || false,
    paymentReference: response.paymentReference || '',
    iban: response.iban || '',
    bic: response.bic || '',
  };
};
